import React from 'react';
import { Box, Typography } from '@mui/material';
import pkg from '../../../package.json';
const { version } = pkg;

const AppFooter = () => {
    return (
        <Box
            component="footer"
            sx={{
                py: 3,
                textAlign: 'center',
            }}
        >
            <Typography variant="body2" color="text.secondary">
                © Dai Minh Phat · v{version}
            </Typography>
        </Box>
    );
};

export default AppFooter;
